module.exports = __webpack_public_path__ + "static/wind_fan-3168fd058e8e4578e3920f59f58b21fc.jpeg";